import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import React, { useState } from 'react';
import { CreateDashboardKioskLinkRequest } from 'common/models/Dashboard/DashboardKioskLink';
import { MenuItem } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers-pro';
import moment, { Moment } from 'moment';

interface Props {
  open: boolean;
  dashboardId: number;
  closeHandler: () => void;
  errorHandler?: (message: string) => void;
  addKioskLink: (request: CreateDashboardKioskLinkRequest) => void;
}

export default function AddDashboardKioskDialog({
  open,
  dashboardId,
  closeHandler,
  addKioskLink,
  errorHandler,
}: Props) {
  const [name, setName] = useState<string>('');
  const [refreshTime, setRefreshTime] = useState<number>(10);
  const [expiryDate, setExpiryDate] = useState<Moment | null>(null);
  const [selectedExpiryId, setSelectedExpiryId] = useState<number>(5);

  const handleCreateDashboardKiosk = () => {
    if (name == '' || refreshTime <= 0) {
      return;
    }

    if (selectedExpiryId == -1 && expiryDate == null) {
      errorHandler && errorHandler('Expiry date required.');
      return;
    }
    addKioskLink({
      dashboardId: dashboardId,
      expiry: selectedExpiryId,
      expiryDate: expiryDate ?? null,
      name: name,
      refreshTime: refreshTime,
    } as CreateDashboardKioskLinkRequest);
    handleClose();
  };

  const handleClose = () => {
    setName('');
    setRefreshTime(10);
    setExpiryDate(null);
    setSelectedExpiryId(5);
    closeHandler();
  };
  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>Add new Dashboard Kiosk Link</DialogTitle>
      <DialogContent>
        <TextField
          label="Name"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
          }}
          fullWidth
          variant="outlined"
          sx={{ mt: '15px' }}
          error={name == ''}
          helperText={name == '' ? 'Name is required' : ''}
        />
        <TextField
          label="Refresh Time (In Minutes)"
          value={refreshTime}
          type="number"
          onChange={(e) => {
            setRefreshTime(+e.target.value);
          }}
          fullWidth
          variant="outlined"
          sx={{ mt: '15px' }}
          error={refreshTime <= 0}
          helperText={refreshTime <= 0 ? 'Refresh Time is required' : ''}
        />
        <TextField
          select
          value={selectedExpiryId}
          onChange={({ target }) => setSelectedExpiryId(+target.value)}
          fullWidth
          variant="outlined"
          sx={{ mt: '15px' }}
        >
          <MenuItem value="1">Never</MenuItem>
          <MenuItem value="2">30 Days</MenuItem>
          <MenuItem value="3">60 Days</MenuItem>
          <MenuItem value="4">90 Days</MenuItem>
          <MenuItem value="5">180 Days</MenuItem>
          <MenuItem value="6">1 Year</MenuItem>
          <MenuItem value="7">2 Years</MenuItem>
          <MenuItem value="-1">Custom</MenuItem>
        </TextField>
        {selectedExpiryId == -1 && (
          <DatePicker
            sx={{ mt: '15px', width: '100%' }}
            value={expiryDate}
            onChange={(e) => {
              setExpiryDate(e);
            }}
            slotProps={{ actionBar: { actions: ['clear', 'cancel', 'accept'] } }}
            disablePast
            shouldDisableDate={(date) => moment(date).isSame(moment(), 'day')}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            handleClose();
          }}
        >
          Cancel
        </Button>
        <Button variant="contained" color="success" onClick={handleCreateDashboardKiosk}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
